





























import { defineComponent, ref } from '@vue/composition-api';

const email = 'sangkyoon_park@med.unc.edu';

export default defineComponent({
  name: 'ReportIssuesMenu',
  setup() {
    const copied = ref(false);

    async function copyEmail() {
      try {
        await navigator.clipboard.writeText(email);
        copied.value = true;
      } catch (_) {
        copied.value = false;
      }
    }

    return { copied, copyEmail, email };
  },
});
